// Reads a Server-Sent Events response with fetch, so the login token can go in the Authorization
// header (EventSource can't send headers, and a JWT must never be put in a URL).
//   await sseFetch(url, { method, body, signal, onEvent: (event, data) => {} })
// Resolves when the server ends the stream; rejects on an HTTP error (err.status, err.message from
// the JSON body) or a network error. Abort with an AbortController (err.name === 'AbortError').
import axios from 'axios';

export async function sseFetch(url, { method = 'GET', body, signal, onEvent } = {}) {
  const headers = { Accept: 'text/event-stream' };
  const auth = axios.defaults.headers.common && axios.defaults.headers.common.Authorization;
  if (auth) headers.Authorization = auth;
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  const res = await fetch(url, { method, headers, body: body !== undefined ? JSON.stringify(body) : undefined, signal });
  if (!res.ok) {
    let msg = '';
    try { msg = (await res.json()).error; } catch (_) { }
    throw Object.assign(new Error(msg || `HTTP ${res.status}`), { status: res.status });
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf('\n\n')) >= 0) {
      const block = buf.slice(0, i);
      buf = buf.slice(i + 2);
      let event = 'message';
      let data = '';
      for (const line of block.split('\n')) {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data += line.slice(5).trim();
      }
      if (!data) continue; // ": ping" comments, "retry:"
      let parsed = data;
      try { parsed = JSON.parse(data); } catch (_) { }
      onEvent && onEvent(event, parsed);
    }
  }
}
